import { Badge } from 'react-bootstrap'
import { Table } from '@ztechapps/webui.data-tools'
import { Alert } from '@ztechapps/webui.util'
import { formatNumber } from '@ztechapps/common.utils'
import type { Product, ProductUsedIn } from '@ztechapps/common.contract'
import type { UseDocumentResult } from '@ztechapps/common.hook'
import React from 'react'
import { ProductWidget } from '../ProductWidget'

export type ProductUsageProps = {
  productDocument: UseDocumentResult<Product>
}

/**
 * Displays a table of parent products that use this product in their bill of materials.
 * Shows the "Used In" relationship - where this product is used as a sub-component.
 */
export const ProductUsage = ({ productDocument }: ProductUsageProps) => {
  const { document, loading, error } = productDocument
  const usedInProducts = document?.usedInProducts ?? []

  return (
    <Table
      dataArray={usedInProducts}
      loading={loading}
      error={error}
      scrollable={true}
      height={'40vh'}
      tableClassName="table table-hover"
      emptyContent={<Alert type="info" text="This product is not used in any assemblies." className="mb-0" />}
      head={
        <thead>
          <tr className="table-secondary">
            <th style={{ width: '150px' }}>Code</th>
            <th>Name</th>
            <th style={{ width: '100px' }} className="text-end">
              Quantity
            </th>
            <th style={{ width: '100px' }} className="text-center">
              Required
            </th>
          </tr>
        </thead>
      }
      row={(item: ProductUsedIn) => {
        const { parentProduct, quantity, requiredToBuild } = item

        return (
          <tr key={parentProduct._id}>
            <td>
              <ProductWidget
                title={parentProduct?.name || parentProduct?.code}
                code={parentProduct?.code}
                _id={parentProduct?._id}
              />
            </td>
            <td>{parentProduct.name}</td>
            <td className="text-end">{formatNumber(quantity)}</td>
            <td className="text-center">
              {requiredToBuild ? <Badge bg="success">Yes</Badge> : <Badge bg="secondary">No</Badge>}
            </td>
          </tr>
        )
      }}
    />
  )
}
